import { Chart, useChart } from '@chakra-ui/charts';
import { FormatNumber, HStack, Stat } from '@chakra-ui/react';
import { Area, AreaChart } from 'recharts';

const Sparkline = () => {
  const chart = useChart({
    data: [
      { value: 10 },
      { value: 16 },
      { value: 19 },
      { value: 15 },
      { value: 12 },
      { value: 15 },
      { value: 10 },
      { value: 18 },
    ],
    series: [{ name: 'value', color: 'teal.solid' }],
  });

  return (
    <Chart.Root width="28" height="12" chart={chart}>
      <AreaChart data={chart.data}>
        {chart.series.map((item) => (
          <Area
            key={item.name}
            isAnimationActive={false}
            dataKey={chart.key(item.name)}
            fill={chart.color(item.color) as string}
            fillOpacity={0.2}
            stroke={chart.color(item.color) as string}
            strokeWidth={2}
          />
        ))}
      </AreaChart>
    </Chart.Root>
  );
};

interface Props {
  label: string;
  val: number;
}
const SimpleStatsCard = ({ label, val }: Props) => {
  return (
    <Stat.Root
      w="100%"
      bg="sidebar.background"
      borderColor="border.light"
      _hover={{ bg: 'sidebar.hover' }}
      cursor="default"
      borderWidth="1px"
      p="4"
      rounded="md"
    >
      <Stat.Label>{label}</Stat.Label>
      <HStack justify="space-between">
        <Stat.ValueText>
          <FormatNumber value={val} />
        </Stat.ValueText>
        <Sparkline />
      </HStack>
    </Stat.Root>
  );
};

export default SimpleStatsCard;
